import vue from "vue";

const state = {
  activeTable: {
    id: "",
    source_id: "",
    fields: [],
    data: {},
    full: false,
    updated: false,
    limit: 1000
  },
  activeFields: { fields: null, update: false },
  socketData: { data: {}, action: null },
  sortConfig: null,
  filters: {
    filtersConfigs: [],
    openFilter: ""
  },
  tableLoading: false,
  showButton: false,
  update: false
};

const mutations = {
  SHOW_DATA_INCREASE_BUTTON(state, value) {
    vue.set(state, "showButton", value);
  },
  SET_TABLE_LOADING(state, value) {
    vue.set(state, "tableLoading", value);
  },
  SET_ACTIVE_TABLE(
    state,
    { id, source_id, full, fields, data, limit, name, geomType, dataLength }
  ) {
    const activeTable = {
      updated: true,
      id,
      source_id,
      fields,
      data,
      full,
      limit,
      name,
      geomType,
      dataLength
    };

    vue.set(state, "activeTable", activeTable);
  },
  UPDATE_ACTIVE_TABLE(state, val = true) {
    vue.set(state, "update", val);
  },
  SET_ACTIVE_FIELDS(state, { fields, update = false }) {
    vue.set(state, "activeFields", { fields, update });
  },
  UPDATE_ACTIVE_BOOKTABLE(state, { source_id, data, action }) {
    const activeTable = state.activeTable;
    if (activeTable.source_id === source_id) {
      vue.set(state.socketData, "data", {});
      Object.keys(data).forEach(e => {
        vue.set(state.socketData.data, e, data[e]);
        vue.set(state.socketData, "action", action);
      });
    }
  },
  SET_TABLE_SORT_CONFIG(state, { attr, sortOrder }) {
    const sortConfig = { attr, sortOrder };
    vue.set(state, "sortConfig", sortConfig);
  },
  REMOVE_TABLE_SORT_CONFIG(state) {
    vue.set(state, "sortConfig", null);
  },
  SET_TABLE_OPEN_FITLER(state, id) {
    vue.set(state.filters, "openFilter", id);
  },
  SET_TABLE_FILTER(state, { name, id, field, op, type, value, active }) {
    const filterConfig = {
      name,
      id,
      field,
      op,
      type,
      value,
      active
    };
    let index;

    state.filters.filtersConfigs.forEach((e, i) => {
      if (e.id === id) index = i;
    });

    if (index || index === 0) {
      vue.set(state.filters.filtersConfigs, index, filterConfig);
    } else {
      state.filters.filtersConfigs.push(filterConfig);
    }
  },
  TOGGLE_TABLE_FILTERS(state, { id, value, all = false }) {
    if (!all) {
      let index;

      state.filters.filtersConfigs.forEach((e, i) => {
        if (e.id === id) index = i;
      });
      vue.set(state.filters.filtersConfigs[index], "active", value);
    } else {
      state.filters.filtersConfigs.map(e => {
        e.active = !value;
        return e;
      });
    }
  },
  DELETE_TABLE_FILTER(state, id) {
    let index;

    state.filters.filtersConfigs.forEach((e, i) => {
      if (e.id === id) index = i;
    });
    state.filters.filtersConfigs.splice(index, 1);
  },
  CLEAR_TABLE_FILTER(state) {
    const filtersLength = state.filters.filtersConfigs.length;

    state.filters.filtersConfigs.splice(0, filtersLength);
  }
};

export default {
  state,
  mutations
};
